export default "__VITE_ASSET__U4glus0B__"